jQuery(function($) {
    'use strict';

    var AppTracking = function() {}

    AppTracking.prototype.init = function() {
        // Matomo
        this.trackMatomo = function(eventTarget, eventCategory = 'generic', eventType = 'Button Click') {
            if (typeof window._paq !== 'undefined') {
                window._paq.push(['trackEvent', eventCategory, eventType, eventTarget]);
            }
        };

        // Google
        this.trackGoogle = function(eventTarget) {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    'event': eventTarget,
                });
            }
        };

        // Meta (Facebook)
        this.trackMeta = function(eventTarget) {
            if (typeof window.fbq !== 'undefined') {
                window.fbq('track', eventTarget);
            }
        };

        // Trigger all tracking functions
        this.triggerTracking = function(eventTarget, category='generic') {
            this.trackMatomo(eventTarget, category);
            this.trackGoogle(eventTarget);
            this.trackMeta(eventTarget);
        };

        const self = this; // Reference to this object
        // Add event listeners to navbar-meta items
        const navMetaItems = document.querySelectorAll('.navbar-meta .nav-item .nav-link');
        navMetaItems.forEach(item => {
            item.addEventListener('click', function() {
                const trackingClass = Array.from(this.classList).find(cls => cls.startsWith('tracking-'));
                const clickTarget = trackingClass ? trackingClass.split('tracking-')[1] : this.getAttribute('data-target');
                console.log('clickTarget:', clickTarget);
                self.triggerTracking(clickTarget, 'contact');
            });
        });

        //TODO - Add event listeners to NinjaForms submit buttons
        // Add event listeners to forms with nf-response-msg
        // const formContainers = document.querySelectorAll('div[id^="nf-form-"]');
        // formContainers.forEach(container => {
        //     const responseMsg = container.querySelector('.nf-response-msg');
        //     if (responseMsg) {
        //         console.log('Setting up observer for:', container.id);
        //         const observer = new MutationObserver(function(mutationsList) {
        //             for (let mutation of mutationsList) {
        //                 if (mutation.type === 'childList' && responseMsg.innerHTML.trim() !== '') {
        //                     const formId = container.id;
        //                     console.log('Form response detected for:', formId);
        //                     self.trackMatomo(formId, 'form', 'Form Submission');
        //                     self.trackGoogle(formId);
        //                     self.trackMeta(formId);
        //                     break;
        //                 }
        //             }
        //         });

        //         observer.observe(responseMsg, { childList: true });
        //     }
        // });
    }

    $.AppTracking = new AppTracking;
    $.AppTracking.Constructor = AppTracking;

    // Attach instance to window
    window.AppTrackingInstance = $.App;
});

jQuery(function($) {
    'use strict';

    $.AppTracking.init();
});
